export default __webpack_public_path__ + "static/media/staff.dce50228.svg";